import { useState } from "react"
import BaseApi from "../../api/api"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { Modal } from "../../features/Modal/Modal"
import { Checkbox, Button } from "@radix-ui/themes"

type SimalandCartButtonProps = {
  shopIdent: string
  selectedSupplyIds: (number | string)[]
}

export const SimalandCartButton = ({
  shopIdent,
  selectedSupplyIds,
}: SimalandCartButtonProps) => {
  const [showModal, setShowModal] = useState(false)
  const [clearCart, setClearCart] = useState(false)
  const [errArticles, setErrArticles] = useState<string[]>([])

  const handleAddToCart = () => {
    setShowModal(false)
    BaseApi.addSupplyToSimalandCart(
      selectedSupplyIds.map(String),
      shopIdent,
      clearCart,
    ).then(({ data }) => {
      const result = data.data
      if (result.errArticles.length) {
        setErrArticles(result.errArticles)
      }
      NotificationService.showNotification({
        level: "success",
        message: `Добавлено в корзину Simaland: ${result?.added.length} позиций`,
      })
    })
    setClearCart(false)
  }

  return (
    <>
      <Button
        disabled={!selectedSupplyIds.length}
        onClick={() => setShowModal(true)}
      >
        Добавить в корзину Simaland
      </Button>
      <Modal
        isOpen={showModal}
        header="Добавить в корзину Simaland"
        content={
          <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Checkbox
              checked={clearCart}
              onCheckedChange={(value) => setClearCart(value === true)}
            />
            Очистить корзину перед добавлением
          </label>
        }
        okContent="Добавить"
        onOk={handleAddToCart}
        onClose={() => {
          setShowModal(false)
          setClearCart(false)
        }}
      />
      <Modal
        isOpen={errArticles.length > 0}
        header="Не найдены артикулы в перекодировке"
        content={
          <ul>
            {errArticles.map((article, i) => (
              <li key={i}>{article}</li>
            ))}
          </ul>
        }
        onClose={() => setErrArticles([])}
        onOk={() => setErrArticles([])}
        hideCancelBtn
      />
    </>
  )
}
